import styled from 'styled-components'

export const ContainerSectionHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 24px;
  width: 100%;
`
